export default __webpack_public_path__ + "dd728f4a4fb5a51f68659d6d501db415.svg";